// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Menu, Transition} from '@headlessui/react';
import {useNavigate} from '@shopify/hydrogen';
import {Customer} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';
import {useAlert} from 'react-alert';
import {deleteCookie} from 'cookies-next';

import {useSignout} from '~/hooks';
// import {UserIcon} from '../icons';
import {NavigationUserIcon} from '~/components';
import {TOKEN_NAME} from '~/utils/constants';

type Props = {
  isHome?: boolean;
  isScrolled?: boolean;
  position?: 'top' | 'bottom';
  customer: Customer;
};

export function AccountPopup({
  // isHome = false,
  // isScrolled = false,
  position = 'bottom',
  customer,
}: Props) {
  const alert = useAlert();
  const {signOut} = useSignout();
  const navigate = useNavigate();

  const onSignOut = async () => {
    const result = await signOut();
    if (result.status !== 200) {
      const body = await result.json();
      alert.error(body.errors);
    } else {
      alert.success('Account Logged out!');
      navigate('/account/logout', {
        replace: true,
        reloadDocument: true,
      });
    }
  };

  return (
    <Menu
      as="div"
      className="relative inline-block place-items-center items-center justify-center text-left text-black"
    >
      <Menu.Button className="inline-flex h-full w-full items-center justify-center self-center duration-300">
        <NavigationUserIcon className="pt-1" />
      </Menu.Button>
      <Menu.Items
        className={clsx(
          'absolute z-50 w-max divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
          position === 'bottom'
            ? customer
              ? 'md:bottom=[60px] right-[-70px] top-[60px]'
              : 'md:bottom=[60px] left-[-30px] top-[60px]'
            : 'right-0 top-[40px]',
        )}
      >
        <Transition
          as="div"
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          className="py-1"
        >
          {customer?.email ? (
            <>
              <div className="group flex w-full flex-col border-b-gray-200 px-4 pb-2 pt-4">
                <div>Signed in as</div>
                <div className="text-ellipsis whitespace-nowrap text-sm font-bold">
                  {customer.email}
                </div>
              </div>
              <hr className="my-2" />
              <Menu.Item>
                {({active}: {active: boolean}) => (
                  <a
                    href="/account"
                    className={clsx(
                      ' group flex w-full items-center px-4 py-2 text-sm',
                      !active ? 'text-gray-900' : 'bg-gray-200',
                    )}
                  >
                    Account
                  </a>
                )}
              </Menu.Item>
              <hr className="my-2" />
              <Menu.Item>
                {({active}: {active: boolean}) => (
                  <button
                    onClick={() => onSignOut()}
                    className={clsx(
                      ' group flex w-full items-center px-4 py-2 text-sm',
                      !active ? 'text-gray-900' : 'bg-gray-200',
                    )}
                  >
                    Logout
                  </button>
                )}
              </Menu.Item>
            </>
          ) : (
            <>
              <Menu.Item>
                {({active}: {active: boolean}) => (
                  <a
                    href="/account/login"
                    className={clsx(
                      ' group flex w-full items-center px-4 py-2 text-sm',
                      !active ? 'text-gray-900' : 'bg-gray-200',
                    )}
                  >
                    Login
                  </a>
                )}
              </Menu.Item>
              <Menu.Item>
                {({active}: {active: boolean}) => (
                  <a
                    href="/account/register"
                    className={clsx(
                      ' group flex w-full items-center px-4 py-2 text-sm',
                      !active ? 'text-gray-900' : 'bg-gray-200',
                    )}
                  >
                    Sign Up
                  </a>
                )}
              </Menu.Item>
            </>
          )}
        </Transition>
      </Menu.Items>
    </Menu>
  );
}
